import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/clubVacationBookings',
        name: 'clubVacationBookings',
        meta: { sideMenuLabel: "Prenotazioni vacanze" },
        component: () => import("./views/clubVacationBookings.vue")
    },
    {
        path: '/clubVacationBooking/:identifier',
        name: 'clubVacationBookingDetail',
        meta: { classes: "" },
        component: () => import("./views/clubVacationBookingDetail.vue")
    }
];

export default routes;